<template>
  <BaseModal id="new-admin-form" :value="true" @input="$emit('closed')">
    <h1 class="mb-4 font-bold text-2xl">Create admin</h1>
    <div class="flex flex-col">
      <form @submit.prevent="createAdmin">
        <div class="form__field">
          <input
            name="name"
            class="bordered regular full"
            type="text"
            v-model="name"
            placeholder="Name"
          />
        </div>
        <div class="form__field">
          <input
            name="email"
            type="email"
            class="bordered regular full"
            v-model="email"
            placeholder="Email"
          />
        </div>
        <div
          v-if="errorMessage"
          class="bg-red-500 p-2 w-full text-white rounded-md"
        >
          {{ errorMessage }}
        </div>
        <div class="form__field">
          <input
            type="submit"
            class="btn-dark-button mt-2"
            :value="loading ? 'Loading...' : 'Create admin'"
            :disabled="loading"
          />
        </div>
      </form>
    </div>
  </BaseModal>
</template>

<script>
import { createAdmin as createAdminApi } from "@/api/masterAdmin/AdminUsersService.js";
export default {
  name: "CreateAdminModal",
  data() {
    return {
      name: "",
      email: "",
      loading: false,
      errorMessage: ""
    };
  },
  methods: {
    createAdmin() {
      this.loading = true;
      this.errorMessage = "";
      const params = {
        name: this.name,
        email: this.email
      };
      console.log(params);
      createAdminApi(params)
        .then(res => {
          this.$emit("admin-created");
          this.$toast.success("Admin created successfully");
          this.$router.push({
            name: "UserPage",
            params: { userId: res.id }
          });
        })
        .catch(error => {
          console.log(error.response.data);
          this.errorMessage = error.response.data;
          this.$toast.error(
            'Error creating admin "' + error.response.data + '"'
          );
        });
      // Call the API to create the admin
      this.loading = false;
    }
  }
};
</script>

<style>
#new-admin-form .content {
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
  align-items: center;
}
</style>
